var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveSwitchLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 67,
    viewBox: "0 0 51 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8878 53.6957L50.1166 54.3754C50.4219 53.8234 50.3217 53.1356 49.8716 52.6936C49.4215 52.2517 48.732 52.1641 48.1857 52.4795L48.8878 53.6957ZM41.567 64.0295C41.1916 64.7081 41.4374 65.5626 42.1161 65.938C42.7947 66.3134 43.6492 66.0675 44.0246 65.3889L41.567 64.0295ZM14.4283 3.01519C15.0327 2.52922 15.1288 1.6453 14.6428 1.04089C14.1568 0.436479 13.2729 0.340462 12.6685 0.826427L14.4283 3.01519ZM48.1857 52.4795C34.0462 60.643 15.8417 55.6496 7.53972 41.2702L5.10748 42.6744C14.1665 58.3651 34.0753 63.8692 49.5899 54.9118L48.1857 52.4795ZM47.659 53.016L41.567 64.0295L44.0246 65.3889L50.1166 54.3754L47.659 53.016ZM7.53972 41.2702C0.0167289 28.24 3.23498 12.015 14.4283 3.01519L12.6685 0.826427C0.389523 10.6992 -3.10419 28.4514 5.10748 42.6744L7.53972 41.2702Z",
    fill: "#525D71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSwitchLeft);
export default __webpack_public_path__ + "static/media/active-switch-left.332772371e6c8660b44e017f2f3ff3ea.svg";
export { ForwardRef as ReactComponent };